<template>
    <div id="page-bet-other-detail">
        <div class="vx-card">
            <vs-table
                stripe
                :data="cheatDetail"
            >
                <template slot="thead">
                    <vs-th
                        :key="h.id" 
                        v-for="h in header"
                    >
                        {{ h.title }}
                    </vs-th>
                </template>
                <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :key="h.id" v-for="h in header" :data="data[indextr][h.field]">
                            <template v-if="h.render">
                                {{ h.render(data[indextr]) }}
                            </template>
                            <template v-else>
                                {{ data[indextr][h.field] }}
                            </template>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </div>
</template>

<style lang="css">
/* #page-cheat-detail .con-tab.vs-tabs--content{
    padding: 1px;
}
#page-cheat-detail .con-vs-chip{
    top: 0px;
    border-radius: 20px;
    color: #000;
    min-height: 20px;
    min-width: 20px;
}
#page-cheat-detail .bet_key_border{
    border-top: 10px solid #ddd;
}
#page-cheat-detail .bet_key{
    color: rgb(255, 71, 87);
}
#page-cheat-detail .bet_dup{
    color: rgb(31, 116, 255);
}
#page-cheat-detail .vs-tabs--li button.vs-tabs--btn{
    padding: 7px;
} */
</style>

<script>
import { mapGetters } from 'vuex';
import vSelect from 'vue-select';
import moment from "moment";

export default {
    data(){
        return {
            header: [ 
                { title:"Tên thành viên", field:"member_name", render: function(data) {return data.member_name.toUpperCase();} },
                { title:"Sport", field:"sport" },
                { title:"Ngày", field:"bet_time", render: function(data){ return moment(data.bet_time).format("DD-MM-YYYY|HH:mm:ss") } },
                { title:"IP", field:"bet_ip" }, 
                { title:"Sàn", field:"board_id", render: function(data){ return data.board_id == 1 ? "ibet" : data.board_id == 2 ? "sbobet" : "unknown"; }},
                { title:"Chọn", field:"bet_choice", render: function(data){ return `${data.bet_choice} ${data.bet_handicap} ${data.bet_favorite}` } },
                { title:"Trận", field:"bet_match" }, 
                { title:"Loại", field:"bet_type" }, 
                { title:"Odds", field:"bet_odds" },
                { title:"Stake", field:"bet_stake" },
                { title:"Status", field:"bet_status" },
            ],
            cheatDetail: [],
        }
    },
    methods:{
        fetchCheatDetail(member_name, from, to) {
            let vm = this;
            this.$http.get("bets/other-detail?member_name="+member_name+"&from="+from+"&to="+to).then((res) => {
                vm.cheatDetail = res.data.data;
            });
        }
    },
    created(){
        let member_name = this.$route.query.member_name;
        let from = this.$route.query.from;
        let to = this.$route.query.to;

        this.fetchCheatDetail(member_name, from, to);
    }
};
</script>

<style>
.swal2-container{
    z-index: 99999;
}
</style>
